import React, { useState, useEffect } from "react";

import { HashRouter as Router } from "react-router-dom";

import { BASENAME } from "./services/constants";

import MainRouter from "./routers/MainRouter";
import Footer from "./components/navigation/footer";
import Header from "./components/navigation/header";

import AuthService from "./services/auth.service.ts";

import "bootstrap/dist/css/bootstrap.css";
import { useIsAuthenticated } from "@azure/msal-react";

const darkModeStorageKey = "_dark_mode";

function App() {
  // Get the value in the local storage, if there is one. If not, use false instead
  const localStorageIsDarkmode =
    localStorage.getItem(darkModeStorageKey) == null
      ? false
      : localStorage.getItem(darkModeStorageKey) === "true";

  const [isDarkMode, setDarkMode] = useState(localStorageIsDarkmode);
  const [isAdmin, setIsAdmin] = useState(null);

  const isLoggedIn = useIsAuthenticated();

  const setDarkModeWithStorage = (newState) => {
    setDarkMode(newState);
    localStorage.setItem(darkModeStorageKey, newState);
  };

  useEffect(() => {
    document.querySelector("body").className =
      "full-height" + (isDarkMode && " dark-page");
  }, [isDarkMode]);

  useEffect(() => {
    if (isLoggedIn) {
      setIsAdmin(null);
      AuthService.isCoach().then((result) => {
        console.log("Coaches:", result);
        setIsAdmin(result);
      });
    } else {
      setIsAdmin(false);
    }
  }, [isLoggedIn]);

  console.log("isLoggedIn:", isLoggedIn);
  console.log("isAdmin:", isAdmin);

  return (
    <div className={"app full-height " + (isDarkMode && " app-dark")}>
      <Router basename={BASENAME}>
        <Header
          isDarkmodeActive={isDarkMode}
          onChangeDarkmode={(newState) => setDarkModeWithStorage(newState)}
          isSessionActive={isLoggedIn}
          isAdminSessionActive={isAdmin}
          onSignOut={() => {}}
        />
        <main className="fill-height">
          <MainRouter
            isAdmin={isAdmin}
            onSessionStateChange={(newState) => setIsLoggedIn(newState)}
          />
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
